import { render } from "./FacilitySeatingCapacityChart.vue?vue&type=template&id=b922d804&scoped=true"
import script from "./FacilitySeatingCapacityChart.vue?vue&type=script&lang=js"
export * from "./FacilitySeatingCapacityChart.vue?vue&type=script&lang=js"

import "./FacilitySeatingCapacityChart.vue?vue&type=style&index=0&id=b922d804&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b922d804"

export default script